module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Riederalp_16.07.08-6c7f2f6796c45d398438b4bc0a340448.png";